import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface CalendarFooterProps {
  handleCancel: () => void;
  handleApply: () => void;
}

export function CalendarFooter({ handleCancel, handleApply }: CalendarFooterProps) {
  const { t } = useTranslation();
  return (
    <div className="flex justify-end">
      <Button variant="outline" size="sm" onClick={handleCancel} className="mr-2">
        {t('common.cancel')}
      </Button>
      <Button variant="default" size="sm" onClick={handleApply}>
        {t('common.apply')}
      </Button>
    </div>
  );
}
